import { campaignDataFiles } from "../constants";

export async function getCampaignData () {
    return fetch(campaignDataFiles.BTC_CHECKLIST)
        .then((response) => response.json())
        .then((checklist) => (checklist))
        .catch((error) => (error));
}
